var map = {
	"./config.dev": 51465,
	"./config.dev.js": 51465,
	"./config.js": 23792,
	"./config.poc1": 47909,
	"./config.poc1.js": 47909,
	"./config.poc2": 83484,
	"./config.poc2.js": 83484,
	"./config.prod": 59601,
	"./config.prod.js": 59601,
	"./config.prodtest": 43217,
	"./config.prodtest.js": 43217,
	"./config.test": 62920,
	"./config.test.js": 62920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42574;